import {
  INNER_SEPARATOR,
  ITEM_SEPARATOR,
} from '../employee-by-department-filter/config';

export function parseCommaSeparatedValues(value: string): string[] {
  return value
    .split(',')
    .map((v) => v.trim())
    .filter((v) => v.length > 0);
}

export function hasItemValue(paramValue: string, itemIndex: number): boolean {
  if (!paramValue) {
    return false;
  }

  const items = paramValue.split(ITEM_SEPARATOR);
  const currentItem = items[itemIndex];

  if (!currentItem) {
    return false;
  }

  const itemWithoutState = currentItem.replace(/\|closed$|\|open$/, '');

  const parts = itemWithoutState.split(INNER_SEPARATOR);
  const [department, range, timeframe] = parts;

  const hasDepartment = !!department?.trim();
  const hasRange = !!range?.trim();
  const hasTimeframe = !!timeframe?.trim();

  return hasDepartment || hasRange || hasTimeframe;
}
